import React, { FC } from 'react'
import { Toast } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamation,
  IconDefinition,
  faInfo,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'

import './styles.scss'

export enum ToastTypeEnum {
  INFO = 'Info',
  WARNING = 'Warning',
  ERROR = 'Error',
}

export interface ToastType {
  type: ToastTypeEnum
  message: string
  fullscreen?: boolean
  delay?: number
  show?: boolean
}

interface Props {
  toasts?: ToastType[]
  onClose: () => void
}

const Toasts: FC<Props> = ({ toasts = [], onClose }) => {
  return (
    <div className="toasts">
      {toasts.map((toast, i) => {
        let icon: IconDefinition
        let color: string

        switch (toast.type) {
          case ToastTypeEnum.ERROR:
            icon = faExclamation
            color = '#cc3300'
            break
          case ToastTypeEnum.INFO:
            icon = faInfo
            color = 'blue'
            break
          case ToastTypeEnum.WARNING:
          default:
            icon = faExclamationTriangle
            color = '#ffcc00'
        }

        return (
          <Toast
            key={`toast-${toast.type}-${i + 1}`}
            autohide
            show={toast.show}
            delay={toast.delay}
            onClose={onClose}
            className={toast.fullscreen ? 'toast-fullscreen' : ''}
          >
            <Toast.Header>
              <div className="left">
                <FontAwesomeIcon icon={icon} color={color} className="icon" />
                <span>{toast.type}</span>
              </div>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        )
      })}
    </div>
  )
}

export default Toasts
